/**
 * Feature Card Service
 * Handles feature card API calls (public endpoint)
 */

import { API_ENDPOINTS } from '../config/api';

export interface FeatureCard {
  id: string;
  title: string;
  description: string;
  iconName: string;
  gradientFrom: string;
  gradientTo: string;
  displayOrder: number;
}

/**
 * Get all active feature cards
 * Public endpoint - no authentication required
 */
export const getFeatureCards = async (): Promise<FeatureCard[]> => {
  try {
    const response = await fetch(API_ENDPOINTS.FEATURE_CARDS.LIST);

    if (!response.ok) {
      throw new Error(`Failed to fetch feature cards: ${response.statusText}`);
    }

    return await response.json();
  } catch (error) {
    console.error('Error fetching feature cards:', error);
    throw error;
  }
};
